import http from "./httpService";

const apiEndpoint = "/client/service";

function serviceUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getServices(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getService(serviceId) {
  return http.get(serviceUrl(serviceId));
}

export function saveService(service) {
  if (service.id) {
    const body = { ...service };
    delete body.id;
    return http.put(serviceUrl(service.id), body);
  }

  return http.post(apiEndpoint, service);
}

export function deleteService(serviceId) {
  return http.delete(serviceUrl(serviceId));
}
